import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import TypeBadge from "./TypeBadge";
import { formatDate } from "@/utils/format";

export default function ContentListItem({ item }: { item: ContentItem }) {
  return (
    <Link
      to={`/detail/${item.type}/${item.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row md:p-5"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-lg bg-background-100 sm:h-32 sm:w-48">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - 百度一下`}
          className="h-full w-full object-cover object-top"
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <TypeBadge type={item.type} />
          <span className="rounded bg-background-100 px-1.5 py-0.5 text-xs text-foreground-600">
            {item.category}
          </span>
        </div>

        <h3 className="line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
          {item.title}
        </h3>

        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-newspaper-line" />
            {item.source}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {formatDate(item.date)}
          </span>
          {item.duration && (
            <span className="flex items-center gap-1">
              <i className="ri-play-circle-line" />
              {item.duration}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}